import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useAvApi } from '@app-velocity/av-api-v2';

export const useCancelAiExtendedReviewMutation = () => {
  const { sims } = useAvApi();

  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['ai-review', 'finish'],
    mutationFn: async ({
      reviewId,
    }: {
      shareToken: string;
      scenarioId: string;
      workspaceId: string;
      reviewId: string;
    }) => {
      if (!reviewId) return;

      const res = await sims.postSimulationStopExtendedById(null, {
        id: reviewId,
      });

      return res.data;
    },
    onSuccess: (_, { workspaceId, scenarioId, shareToken, reviewId }) => {
      queryClient.invalidateQueries({
        queryKey: ['scenario-ai-reviews', workspaceId, scenarioId],
        refetchType: 'all',
      });
      queryClient.invalidateQueries({
        queryKey: ['scenario-ai-reviews-chat', shareToken, reviewId],
        refetchType: 'all',
      });
      queryClient.invalidateQueries({
        queryKey: ['ai-review', shareToken, reviewId],
        refetchType: 'all',
      });
      queryClient.invalidateQueries({
        queryKey: ['scenario', workspaceId, scenarioId],
        refetchType: 'all',
      });
    },
  });
};
